import React, { useState } from 'react'

const API = process.env.REACT_APP_API_URL || 'https://sunshoos-v2.onrender.com'

const BLANK_DIRECTOR = { name: '', dob: '', nationality: 'British', address: '', occupation: '', nino: '' }
const BLANK_SHAREHOLDER = { name: '', address: '', shares: '100', share_class: 'Ordinary', nominal_value: '1.00' }
const SIC_LIST = [
  '62012 — Business and domestic software development',
  '62020 — IT consultancy',
  '69201 — Accounting and auditing',
  '69202 — Bookkeeping',
  '70229 — Management consultancy',
  '74909 — Other professional services',
  '47910 — Retail via mail order or internet',
  '41100 — Property development',
  '68209 — Other letting and operating of own property',
  '56101 — Restaurants and cafes',
  '43210 — Electrical installation',
  '43220 — Plumbing, heating and air-conditioning',
  '49410 — Freight transport by road',
  '85590 — Other education',
]

export default function CompanyFormation() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [result, setResult] = useState(null)
  const [saved, setSaved] = useState(false)
  const [activeTab, setActiveTab] = useState('company')

  const [company, setCompany] = useState({
    proposed_name: '', name_ending: 'Limited',
    registered_address: '', registered_country: 'England and Wales',
    sic_code: '62020 — IT consultancy',
    share_capital: '100', currency: 'GBP',
    articles_type: 'Model Articles',
    business_description: '',
  })
  const setC = (k, v) => setCompany(c => ({ ...c, [k]: v }))

  const [directors, setDirectors] = useState([{ ...BLANK_DIRECTOR }])
  const setDir = (i, k, v) => setDirectors(d => d.map((x, idx) => idx === i ? { ...x, [k]: v } : x))
  const addDir = () => setDirectors(d => [...d, { ...BLANK_DIRECTOR }])
  const removeDir = i => setDirectors(d => d.filter((_, idx) => idx !== i))

  const [shareholders, setShareholders] = useState([{ ...BLANK_SHAREHOLDER }])
  const setSh = (i, k, v) => setShareholders(s => s.map((x, idx) => idx === i ? { ...x, [k]: v } : x))
  const addSh = () => setShareholders(s => [...s, { ...BLANK_SHAREHOLDER }])
  const removeSh = i => setShareholders(s => s.filter((_, idx) => idx !== i))

  async function handleGenerate() {
    setLoading(true); setError(''); setResult(null); setSaved(false)
    try {
      const res = await fetch(`${API}/api/formation/generate`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ company, directors, shareholders })
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.detail || 'Server error')
      setResult(data)
    } catch (e) { setError(e.message) }
    setLoading(false)
  }

  async function handleExport(type) {
    try {
      const res = await fetch(`${API}/api/formation/export-${type}`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(result)
      })
      if (!res.ok) throw new Error(`${type} export failed`)
      const blob = await res.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      const name = (result.company?.proposed_name || 'Company').replace(/ /g, '_')
      a.download = `Formation_${name}.${type === 'excel' ? 'xlsx' : 'pdf'}`
      a.click(); URL.revokeObjectURL(url)
    } catch (e) { setError(`Export error: ${e.message}`) }
  }

  async function handleSave() {
    try {
      const res = await fetch(`${API}/api/formation/save`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(result)
      })
      if (!res.ok) throw new Error('Save failed')
      setSaved(true)
    } catch (e) { setError('Save error: ' + e.message) }
  }

  const s = {
    page: { padding: '24px', maxWidth: 1020, margin: '0 auto', fontFamily: 'Calibri, sans-serif' },
    card: { background: '#0f1923', border: '1px solid rgba(201,151,58,0.15)', borderRadius: 10, padding: 22, marginBottom: 18 },
    row: { display: 'flex', gap: 14, marginBottom: 14, flexWrap: 'wrap' },
    label: { fontSize: 11, color: 'rgba(255,255,255,0.45)', marginBottom: 5, display: 'block', textTransform: 'uppercase', letterSpacing: 0.5 },
    input: { background: '#0B1929', border: '1px solid rgba(201,151,58,0.2)', borderRadius: 6, color: '#fff', padding: '8px 12px', fontSize: 13, outline: 'none', width: '100%', boxSizing: 'border-box' },
    tabBar: { display: 'flex', gap: 2, marginBottom: 18, background: '#0B1929', borderRadius: 8, padding: 4 },
    tab: a => ({ flex: 1, padding: '8px 0', borderRadius: 6, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600, background: a ? '#C9973A' : 'transparent', color: a ? '#0B1929' : 'rgba(255,255,255,0.4)', transition: 'all .2s' }),
    btn: (v = 'primary') => ({ padding: '10px 20px', borderRadius: 7, border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: 13, background: v === 'primary' ? '#C9973A' : v === 'green' ? '#1a4a2e' : v === 'blue' ? '#0f2a4a' : v === 'red' ? '#4a1a1a' : '#1a2a4a', color: v === 'primary' ? '#0B1929' : v === 'green' ? '#4ade80' : v === 'blue' ? '#93c5fd' : v === 'red' ? '#f87171' : '#C9973A' }),
    sectionTitle: { fontSize: 11, fontWeight: 700, color: 'rgba(201,151,58,0.7)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 },
    docCard: { padding: 16, borderRadius: 8, background: '#0B1929', border: '1px solid rgba(255,255,255,0.07)', marginBottom: 14 },
    docTitle: { fontSize: 13, fontWeight: 700, color: '#C9973A', marginBottom: 8 },
    docBody: { fontSize: 12, color: 'rgba(255,255,255,0.6)', lineHeight: 1.8, whiteSpace: 'pre-wrap' },
    checkRow: ok => ({ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '9px 12px', borderRadius: 6, marginBottom: 5, background: ok ? 'rgba(74,222,128,0.05)' : 'rgba(251,191,36,0.05)', border: `1px solid ${ok ? 'rgba(74,222,128,0.15)' : 'rgba(251,191,36,0.15)'}` }),
  }

  return (
    <div style={s.page}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#fff', margin: 0 }}>Company Formation</h1>
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.35)', margin: '4px 0 0' }}>
          IN01 · Memorandum · Articles · Share Certificate · Director Consent · Companies House filing
        </p>
      </div>

      {/* Input tabs */}
      <div style={s.tabBar}>
        <button style={s.tab(activeTab === 'company')} onClick={() => setActiveTab('company')}>🏢 Company Details</button>
        <button style={s.tab(activeTab === 'directors')} onClick={() => setActiveTab('directors')}>👤 Directors ({directors.length})</button>
        <button style={s.tab(activeTab === 'shareholders')} onClick={() => setActiveTab('shareholders')}>📊 Shareholders ({shareholders.length})</button>
      </div>

      {/* Company Details */}
      {activeTab === 'company' && (
        <div style={s.card}>
          <div style={s.sectionTitle}>Proposed Company Details</div>
          <div style={s.row}>
            <div style={{ flex: 3, minWidth: 220 }}>
              <label style={s.label}>Proposed Company Name</label>
              <input style={s.input} value={company.proposed_name} onChange={e => setC('proposed_name', e.target.value)} placeholder="e.g. Acme Trading" />
            </div>
            <div style={{ flex: 1, minWidth: 130 }}>
              <label style={s.label}>Name Ending</label>
              <select style={s.input} value={company.name_ending} onChange={e => setC('name_ending', e.target.value)}>
                <option>Limited</option><option>Ltd</option><option>LLP</option>
              </select>
            </div>
            <div style={{ flex: 1, minWidth: 180 }}>
              <label style={s.label}>Registered Country</label>
              <select style={s.input} value={company.registered_country} onChange={e => setC('registered_country', e.target.value)}>
                <option>England and Wales</option>
                <option>Scotland</option>
                <option>Northern Ireland</option>
              </select>
            </div>
          </div>
          <div style={s.row}>
            <div style={{ flex: 3, minWidth: 260 }}>
              <label style={s.label}>Registered Office Address</label>
              <input style={s.input} value={company.registered_address} onChange={e => setC('registered_address', e.target.value)} placeholder="Full address including postcode" />
            </div>
          </div>
          <div style={s.row}>
            <div style={{ flex: 2, minWidth: 240 }}>
              <label style={s.label}>SIC Code</label>
              <select style={s.input} value={company.sic_code} onChange={e => setC('sic_code', e.target.value)}>
                {SIC_LIST.map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            <div style={{ flex: 1, minWidth: 130 }}>
              <label style={s.label}>Articles Type</label>
              <select style={s.input} value={company.articles_type} onChange={e => setC('articles_type', e.target.value)}>
                <option>Model Articles</option>
                <option>Bespoke Articles</option>
              </select>
            </div>
            <div style={{ flex: 1, minWidth: 120 }}>
              <label style={s.label}>Share Capital (£)</label>
              <input style={s.input} type="number" value={company.share_capital} onChange={e => setC('share_capital', e.target.value)} placeholder="100" />
            </div>
            <div style={{ flex: 1, minWidth: 100 }}>
              <label style={s.label}>Currency</label>
              <select style={s.input} value={company.currency} onChange={e => setC('currency', e.target.value)}>
                <option>GBP</option><option>USD</option><option>EUR</option>
              </select>
            </div>
          </div>
          <div style={s.row}>
            <div style={{ flex: 1 }}>
              <label style={s.label}>Business Description (for Memorandum)</label>
              <input style={s.input} value={company.business_description} onChange={e => setC('business_description', e.target.value)} placeholder="e.g. Providing IT consultancy and software development services to UK businesses" />
            </div>
          </div>
        </div>
      )}

      {/* Directors */}
      {activeTab === 'directors' && (
        <div style={s.card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
            <div style={s.sectionTitle}>Directors</div>
            <button style={s.btn('primary')} onClick={addDir}>+ Add Director</button>
          </div>
          {directors.map((d, i) => (
            <div key={i} style={{ padding: 14, borderRadius: 8, background: '#0B1929', border: '1px solid rgba(255,255,255,0.07)', marginBottom: 12 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#C9973A', marginBottom: 10 }}>Director {i + 1}</div>
              <div style={s.row}>
                <div style={{ flex: 2, minWidth: 180 }}>
                  <label style={s.label}>Full Name</label>
                  <input style={s.input} value={d.name} onChange={e => setDir(i, 'name', e.target.value)} placeholder="e.g. John Smith" />
                </div>
                <div style={{ flex: 1, minWidth: 130 }}>
                  <label style={s.label}>Date of Birth</label>
                  <input style={s.input} type="date" value={d.dob} onChange={e => setDir(i, 'dob', e.target.value)} />
                </div>
                <div style={{ flex: 1, minWidth: 130 }}>
                  <label style={s.label}>Nationality</label>
                  <input style={s.input} value={d.nationality} onChange={e => setDir(i, 'nationality', e.target.value)} placeholder="British" />
                </div>
                <div style={{ flex: 1, minWidth: 130 }}>
                  <label style={s.label}>Occupation</label>
                  <input style={s.input} value={d.occupation} onChange={e => setDir(i, 'occupation', e.target.value)} placeholder="Director" />
                </div>
              </div>
              <div style={s.row}>
                <div style={{ flex: 3, minWidth: 260 }}>
                  <label style={s.label}>Residential Address</label>
                  <input style={s.input} value={d.address} onChange={e => setDir(i, 'address', e.target.value)} placeholder="Full address" />
                </div>
                <div style={{ flex: 1, minWidth: 140 }}>
                  <label style={s.label}>NI Number</label>
                  <input style={s.input} value={d.nino} onChange={e => setDir(i, 'nino', e.target.value)} placeholder="AB123456C" />
                </div>
              </div>
              {directors.length > 1 && (
                <button style={{ ...s.btn('red'), padding: '6px 12px', fontSize: 11 }} onClick={() => removeDir(i)}>Remove</button>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Shareholders */}
      {activeTab === 'shareholders' && (
        <div style={s.card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
            <div style={s.sectionTitle}>Shareholders</div>
            <button style={s.btn('primary')} onClick={addSh}>+ Add Shareholder</button>
          </div>
          {shareholders.map((sh, i) => (
            <div key={i} style={{ padding: 14, borderRadius: 8, background: '#0B1929', border: '1px solid rgba(255,255,255,0.07)', marginBottom: 12 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#C9973A', marginBottom: 10 }}>Shareholder {i + 1}</div>
              <div style={s.row}>
                <div style={{ flex: 2, minWidth: 180 }}>
                  <label style={s.label}>Full Name</label>
                  <input style={s.input} value={sh.name} onChange={e => setSh(i, 'name', e.target.value)} placeholder="e.g. Jane Smith" />
                </div>
                <div style={{ flex: 1, minWidth: 120 }}>
                  <label style={s.label}>Share Class</label>
                  <select style={s.input} value={sh.share_class} onChange={e => setSh(i, 'share_class', e.target.value)}>
                    <option>Ordinary</option><option>Preference</option><option>Ordinary A</option><option>Ordinary B</option>
                  </select>
                </div>
                <div style={{ flex: 1, minWidth: 110 }}>
                  <label style={s.label}>Number of Shares</label>
                  <input style={s.input} type="number" value={sh.shares} onChange={e => setSh(i, 'shares', e.target.value)} placeholder="100" />
                </div>
                <div style={{ flex: 1, minWidth: 120 }}>
                  <label style={s.label}>Nominal Value (£)</label>
                  <input style={s.input} type="number" value={sh.nominal_value} onChange={e => setSh(i, 'nominal_value', e.target.value)} placeholder="1.00" />
                </div>
              </div>
              <div style={s.row}>
                <div style={{ flex: 1 }}>
                  <label style={s.label}>Address</label>
                  <input style={s.input} value={sh.address} onChange={e => setSh(i, 'address', e.target.value)} placeholder="Full address" />
                </div>
              </div>
              {shareholders.length > 1 && (
                <button style={{ ...s.btn('red'), padding: '6px 12px', fontSize: 11 }} onClick={() => removeSh(i)}>Remove</button>
              )}
            </div>
          ))}
        </div>
      )}

      <div style={{ marginBottom: 20 }}>
        <button style={s.btn('primary')} onClick={handleGenerate} disabled={loading}>
          {loading ? '⏳ Generating formation pack with GPT-4o…' : '▶ Generate Company Formation Pack'}
        </button>
      </div>

      {error && (
        <div style={{ background: 'rgba(220,38,38,0.08)', border: '1px solid rgba(220,38,38,0.25)', borderRadius: 8, padding: '12px 16px', marginBottom: 16, color: '#f87171', fontSize: 13 }}>⚠ {error}</div>
      )}

      {/* Results */}
      {result && (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
            <div>
              <div style={{ fontSize: 17, fontWeight: 700, color: '#fff' }}>{result.company?.proposed_name} {result.company?.name_ending}</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', marginTop: 3 }}>
                {result.company?.registered_country} · {result.company?.sic_code?.split(' — ')[0]}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              <button style={s.btn('green')} onClick={() => handleExport('excel')}>⬇ Excel Checklist</button>
              <button style={s.btn('blue')} onClick={() => handleExport('pdf')}>⬇ PDF Pack</button>
              <button style={s.btn('save')} onClick={handleSave} disabled={saved}>{saved ? '✓ Saved' : '💾 Save'}</button>
            </div>
          </div>

          {/* Documents */}
          {[
            { key: 'memorandum', title: '📄 Memorandum of Association' },
            { key: 'articles', title: '📋 Articles of Association' },
            { key: 'share_certificate', title: '🏷 Share Certificate' },
            { key: 'director_consent', title: '✍️ Director Consent to Act' },
          ].map(({ key, title }) => result.documents?.[key] && (
            <div key={key} style={s.docCard}>
              <div style={s.docTitle}>{title}</div>
              <div style={s.docBody}>{result.documents[key]}</div>
            </div>
          ))}

          {/* IN01 Checklist */}
          {result.in01_checklist?.length > 0 && (
            <div style={s.card}>
              <div style={s.sectionTitle}>IN01 Filing Checklist</div>
              {result.in01_checklist.map((item, i) => (
                <div key={i} style={s.checkRow(item.status === 'ok')}>
                  <span style={{ fontSize: 14, flexShrink: 0 }}>{item.status === 'ok' ? '✅' : '⚠️'}</span>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: item.status === 'ok' ? '#4ade80' : '#FBBF24' }}>{item.title}</div>
                    <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginTop: 2 }}>{item.detail}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  )
}
